<template>
  <div class="about-swiper-all">
    <swiper ref="mySwiper" :options="swiperOptions" class="about-swiper-container pc">
      <swiper-slide>
        <div class="patter-images">
          <img src="@/assets/partner/图片3.png" alt="">
          <img src="@/assets/partner/图片14.png" alt="">
          <img src="@/assets/partner/图片2.png" alt="">
          <img src="@/assets/partner/图片19.png" alt="">
          <img src="@/assets/partner/图片17.png" alt="">
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="patter-images">
          <img src="@/assets/partner/图片20.png" alt="">
          <img src="@/assets/partner/图片4.png" alt="">
          <img src="@/assets/partner/图片5.png" alt="">
          <img src="@/assets/partner/图片6.png" alt="">
          <img src="@/assets/partner/图片12.png" alt="">
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="patter-images">
          <img src="@/assets/partner/图片8.png" alt="">
          <img src="@/assets/partner/图片9.png" alt="">
          <img src="@/assets/partner/图片10.png" alt="">
          <img src="@/assets/partner/图片7.png" alt="">
          <img src="@/assets/partner/图片13.png" alt="">
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="patter-images">
          <img src="@/assets/partner/图片15.png" alt="">
          <img src="@/assets/partner/图片18.png" alt="">
          <img src="@/assets/partner/图片21.png" alt="">
          <img src="@/assets/partner/图片27.png" alt="">
          <img src="@/assets/partner/图片30.png" alt="">
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="patter-images">
          <img src="@/assets/partner/图片31.png" alt="">
          <img src="@/assets/partner/图片25.png" alt="">
          <img src="@/assets/partner/图片24.png" alt="">
          <img src="@/assets/partner/图片26.png" alt="">
          <img src="@/assets/partner/图片32.png" alt="">
        </div>
      </swiper-slide>

    </swiper>
    <swiper ref="mySwiper2" :options="swiper2Options" class="about-swiper-container mobile">
      <swiper-slide>
        <div class="patter-images">
          <img src="@/assets/partner/图片3.png" alt="">
          <img src="@/assets/partner/图片14.png" alt="">
          <img src="@/assets/partner/图片2.png" alt="">
          <img src="@/assets/partner/图片19.png" alt="">
          <img src="@/assets/partner/图片17.png" alt="">
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="patter-images">
          <img src="@/assets/partner/图片20.png" alt="">
          <img src="@/assets/partner/图片4.png" alt="">
          <img src="@/assets/partner/图片5.png" alt="">
          <img src="@/assets/partner/图片6.png" alt="">
          <img src="@/assets/partner/图片12.png" alt="">
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="patter-images">
          <img src="@/assets/partner/图片8.png" alt="">
          <img src="@/assets/partner/图片9.png" alt="">
          <img src="@/assets/partner/图片10.png" alt="">
          <img src="@/assets/partner/图片7.png" alt="">
          <img src="@/assets/partner/图片13.png" alt="">
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="patter-images">
          <img src="@/assets/partner/图片15.png" alt="">
          <img src="@/assets/partner/图片18.png" alt="">
          <img src="@/assets/partner/图片21.png" alt="">
          <img src="@/assets/partner/图片27.png" alt="">
          <img src="@/assets/partner/图片30.png" alt="">
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="patter-images">
          <img src="@/assets/partner/图片31.png" alt="">
          <img src="@/assets/partner/图片25.png" alt="">
          <img src="@/assets/partner/图片24.png" alt="">
          <img src="@/assets/partner/图片26.png" alt="">
          <img src="@/assets/partner/图片32.png" alt="">
        </div>
      </swiper-slide>
    </swiper>
  </div>

</template>

<script>
export default {
  name: "intro-swiper",
  data() {
    return {
      swiperOptions: {
        speed: 4000,
        slidesPerView: 10,
        spaceBetween: 30,
        direction: 'vertical',
        loop: true,
        autoplay: {delay: 0, disableOnInteraction: false},
        breakpoints: {
          640: {slidesPerView: 3, spaceBetween: 0},
        },
      },
      swiper2Options: {
        speed: 4000,
        slidesPerView: 6,
        spaceBetween: 30,
        direction: 'vertical',
        loop: true,
        autoplay: {delay: 0, disableOnInteraction: false},
        breakpoints: {
          640: {slidesPerView: 3, spaceBetween: 0},
        },
      }
    };
  },
  mounted() {
    // 确保DOM渲染后初始化（静态数据）
    this.$nextTick(() => {
      if (this.$refs.mySwiper) {
        this.$refs.mySwiper.$swiper.update();  // 强制更新
      }
      if (this.$refs.mySwiper2) {
        this.$refs.mySwiper2.$swiper.update();  // 强制更新
      }
    });
  }
}
</script>

<style lang="scss">
.about-swiper-all {
  .swiper-container {
    height: 400px;
  }
}

.patter-images {
  display: flex;
  padding: 10px;
  justify-content: space-between;
  img {
    width: 140px;
    height: 60px;
    background: #ffffff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    padding: 10px 20px;
    -o-object-fit: contain;
    object-fit: contain;
    border-radius: 5px;
  }
}


.swiper-wrapper {
  transition-timing-function:linear;
}

.about-swiper-container {
  width: 100%;
  height: 100%;
  position: relative;
  //&:before {
  //    content: '';
  //    width: 100%;
  //    height: 400px;
  //    background: rgba(0, 0, 0, 0.5);
  //    z-index: 2;
  //    position: absolute;
  //    top: 0;
  //    left: 0;
  //}
}

.slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  //object-position: 10% 30%;
}
@media (max-width: 768px) {
  .about-swiper-all .about-swiper-container.mobile .patter-images {
    display: grid;
    padding: 10px;
    grid-template-columns: repeat(5, 1fr);
    justify-content: center;
    text-align: center;
    img {
      width: 50px;
      height: 20px;
      display: block;
      margin: 0 auto 20px auto;
      padding: 10px 5px;
    }
  }
}
</style>
